import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { AuthService } from 'app/core';
import { TreoAnimations } from 'tsui/@treo';
import { TreoValidators } from 'tsui/@treo';

@Component({
  selector: 'auth-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: TreoAnimations,
})
export class AuthResetPasswordComponent implements OnInit, OnDestroy {
  message: any;
  resetPasswordForm: UntypedFormGroup;
  resetPasswordToken: string;

  // Private
  private _unsubscribeAll: Subject<void>;

  /**
   * Constructor
   *
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _activatedRoute: ActivatedRoute,
    private _authService: AuthService,
    private _router: Router,
  ) {
    // Set the defaults
    this.message = null;

    // Set the private defaults
    this._unsubscribeAll = new Subject();

    this.resetPasswordToken = this._activatedRoute.snapshot.queryParamMap.get('reset_password_token');
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Create the form
    this.resetPasswordForm = this._formBuilder.group(
      {
        password: ['', Validators.required],
        confirm_password: ['', Validators.required],
      },
      {
        validators: TreoValidators.mustMatch('password', 'confirm_password'),
      },
    );
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions

    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Go to home page
   */
  goHome(): void {
    window.open('https://www.termsheet.com');
  }

  /**
   * Reset password
   */
  resetPassword(): void {
    // Do nothing if the form is invalid
    if (this.resetPasswordForm.invalid) {
      return;
    }

    // Disable the form
    this.resetPasswordForm.disable();

    // Hide the message
    this.message = null;

    // Do your action here...
    let credentials = this.resetPasswordForm.value;
    credentials.reset_password_token = this.resetPasswordToken;

    // Sign in
    this._authService.resetPassword(credentials).subscribe(
      () => {
        // Navigate to the redirect url
        window.location.replace('accounts');
      },
      (response) => {
        // Re-enable the form
        this.resetPasswordForm.enable();

        // Show the error message
        this.message = {
          appearance: 'outline',
          content: response.error.user_authentication,
          shake: true,
          showIcon: false,
          type: 'error',
        };
      },
    );
  }
}
